import React from "react";
import { useTranslation } from "react-i18next";
import ItemCardInfos from "../itemCard/components/itemCardInfos/itemCardInfos";
import ItemCard from "../itemCard/itemCard";
import Icon from "../../ui/icon/icon";
import { classnames } from "../../../../utils/classnames";
import "./ticketCard.css";

const TicketSubtitle = ({ code, rateName }) => {
	if (code) {
		return (
			<div>
				<div className="wz-member-code">
					<Icon name="idCard" />
					{code}
				</div>
				<div>{rateName}</div>
			</div>
		);
	}
	return rateName;
};

export function TicketCard({ config, ticket, onSubmit, cardStatus = 'default', content, withMargin }) {
    const { t } = useTranslation();
	const _config = ticket || config?.ticket_card;

	const activeStatus = React.useMemo(() => {
        if (['active', 'free', 'paid'].includes(_config.status)) {
            return "valid"
        }
        return _config.status;
    },[_config])

	const name = React.useMemo(() => {
		const full_name = [_config.first_name, _config.last_name];
		return full_name.join(' ');
	}, [_config])

	const actionTicket = React.useMemo(() => {
		if (_config.actions.length === 0) {
			return null;
		}
		return {
			label: t('widget.button.manage.default_label'),
			icon: "arrowRight",
			enabled: _config.actions[0]?.enabled,
			onClick: () => onSubmit({
				data: {
					action: _config.actions[0].type,
					...(_config.actions[0].type !== 'TicketTransferMenuStep'
						? {
							payload: {
								attendee_id: _config.id
							}
						}
						: {
							ticket_transfer_id: _config.id
						}
					)
				}
			})
		}
	}, [_config, onSubmit]);

	return (
		<div className={classnames('wz-ticket-list', {[cardStatus]: cardStatus})}>
			<ItemCard 
				type={'order-card'}
				status={activeStatus}
				title={name}
				subtitle={<TicketSubtitle code={_config.membership_code} rateName={_config.rate_name} />}
				action={actionTicket} 
				email={_config.transfer_email}
				cardStatus={cardStatus}
				additionnalContent={content}
				withMargin={withMargin}
			>
				<ItemCardInfos title={t('widget.information.ticket')} informations={_config.informations} cardStatus={cardStatus}/>
				{_config.resale_status && <ItemCardInfos title={t('widget.information.resale')} informations={_config.resale_informations} />}
			</ItemCard>
		</div>
	);
}
